<template>
  <div>
    <el-dialog
      title="回收权益"
      :visible.sync="visible"
      :before-close="handleClose"
      append-to-body
    >
      <el-form
        ref="form"
        :model="formInfo"
        label-width="120px"
        label-position="right"
        size="small"
        v-loading="loading"
        :rules="formRules"
      >
        <el-form-item label="回收地址">
          <el-input v-model="formInfo.url" clearable></el-input>
        </el-form-item>
        <el-form-item label="用户" prop="subscriberId">
          <el-input v-model="formInfo.subscriberId" clearable></el-input>
        </el-form-item>
        <el-form-item label="权益卡" prop="PrivilegeCardId">
          <el-input v-model="formInfo.PrivilegeCardId" clearable></el-input>
        </el-form-item>
      </el-form>

      <!--footer-->
      <div slot="footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "RecyclePrivilege",
  data() {
    return {
      visible: false,
      loading: false,
      formInfo: {},
      formRules: {
        subscriberId: [
          { required: true, message: "请选择用户", trigger: "blur" }
        ],
        PrivilegeCardId: [
          { required: true, message: "请选择权益卡", trigger: "blur" }
        ],
        reason: [{ required: true, message: "请输入回收原因", trigger: "blur" }]
      }
    };
  },
  methods: {
    open() {
      this.visible = true;
    },
    handleClose() {
      this.visible = false;
    },
    handleConfirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.confirm();
        }
      });
    },
    /**
     * 二次确认
     */
    confirm() {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定"
      })
        .then(() => {
          this._request();
        })
        .catch(() => {});
    },
    _request() {
      this.loading = true;
      axios
        .get(this.formInfo.url, {
          params: {
            subscriberId: this.formInfo.subscriberId,
            id: this.formInfo.PrivilegeCardId
          },
          headers: {
            os: "hohofast",
            "User-Agent": "allscs/2.0.0",
            "X-tag": "hohofast"
          }
        })
        .then(resp => {
          const { status, message } = resp.data;
          if (status == 0) {
            this.$message({
              message: message,
              type: "success"
            });
            this.handleClose();
            this.$emit("refresh");
          } else {
            this.$message({
              message: message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// recycling.vue?23a86608